module.exports = __webpack_public_path__ + "img/H2.2ccef65b.png";